// import React from 'react'
// import { Helmet } from 'react-helmet';

// export default function SettlementServices() {

// const serviceCategories = [
//   {
//     category: "Settlement Services",
//     description:
//       "Our comprehensive Settlement Services streamline the real estate closing process from preparation to post-closing fulfillment, delivering full regulatory compliance, precise documentation, and a smooth transfer of ownership for all parties involved.",
//     services: [
//       {
//         name: "Closing Disclosure Preparation",
//         details:
//           "Produces fully compliant Closing Disclosures in line with TRID requirements, compiling verified loan details, final fees, cash-to-close calculations, and comparisons to the Loan Estimate before secure delivery to borrowers and lenders."
//       },
//       {
//         name: "Pre-CD Preparation",
//         details:
//           "Develops preliminary Closing Disclosures to provide an advance, accurate preview of final loan terms, estimated costs, payment schedules, and adjustments—allowing early review, discrepancy resolution, and smoother finalization."
//       },
//       {
//         name: "Notary Scheduling",
//         details:
//           "Arranges professional notary services (in-person, mobile, or remote online notarization where permitted), including prompt scheduling, identity verification coordination, secure signing sessions, and follow-up for document authentication and compliance."
//       },
//       {
//         name: "Policy Typing",
//         details:
//           "Prepares precise title insurance policies for both owners and lenders, gathering commitment details, customizing policy forms, assembling endorsements, performing final verifications, and ensuring error-free issuance ready for delivery."
//       },
//       {
//         name: "Post Closing Audit",
//         details:
//           "Performs thorough post-closing quality reviews and compliance audits, examining all executed documents, fund disbursements, recording confirmations, and lien releases to identify and resolve any discrepancies while generating detailed reports."
//       },
//       {
//         name: "Recording",
//         details:
//           "Manages efficient document recording via electronic platforms (e.g., Simplifile, CSC) or traditional county methods, preparing packages, submitting deeds/mortgages promptly, tracking status, securing confirmations, and handling returned originals."
//       },
//       {
//         name: "Policy Mailing",
//         details:
//           "Oversees secure distribution of final title insurance policies through physical mailing or electronic upload to lender portals, including packaging, certified tracking, delivery verification, and archiving for future reference."
//       },
//     ],
//   },
// ];


//     return (
//         <div className="bg-white">
//             <Helmet>
//                 <meta charSet="utf-8" />
//                 <title>CityPulse LLC | Settlement Services</title>
//                 <link rel="canonical" href="https://citypulsellc.com/services" />
//             </Helmet>
//             {/* Header */}
//             <section className="relative bg-gradient-to-r from-primary to-primary-dark text-white py-20 overflow-hidden">
//                 <div
//                     className="absolute inset-0 bg-cover bg-center opacity-20"
//                     style={{
//                         backgroundImage: `url('https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')`
//                     }}
//                 ></div>
//                 <div className="absolute inset-0 bg-gradient-to-r from-primary/95 to-primary-dark/95"></div>
//                 <div className="absolute inset-0 bg-grid"></div>

//                 <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                     <div className="glass-card rounded-2xl p-8 md:p-12 inline-block">
//                         <h1 className="text-5xl md:text-6xl font-bold mb-6 text-primary">Settlement Services</h1>
//                         <p className="text-xl text-gray-700 max-w-3xl font-semibold">
//                             We provide end-to-end Settlement Services to ensure transparency, compliance, and successful real estate closings.
//                         </p>
//                     </div>
//                 </div>
//             </section>

//             {/* Services Detail */}
//             <section className="py-20 bg-gray-50">
//                 <div className="max-w-7xl mx-auto px-6 space-y-20">

//                     {serviceCategories.map((category, index) => (
//                         <div key={index}>
//                             {/* <h2 className="text-4xl font-bold text-primary mb-4">
//                                 {category.category}
//                             </h2>
//                             <p className="text-lg text-gray-600 mb-10 max-w-3xl">
//                                 {category.description}
//                             </p> */}

//                             <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//                                 {category.services.map((service, idx) => (
//                                     <div
//                                         key={idx}
//                                         className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition"
//                                     >
//                                         <h3 className="text-xl font-semibold text-primary mb-3">
//                                             {service.name}
//                                         </h3>
//                                         {service.details && (
//                                             <p className="text-gray-700 leading-relaxed">
//                                                 {service.details}
//                                             </p>
//                                         )}
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     ))}

//                 </div>
//             </section>

//             {/* CTA Section */}
//             <section className="relative py-20 bg-primary text-white overflow-hidden">
//                 <div
//                     className="absolute inset-0 bg-cover bg-center opacity-20"
//                 // style={{
//                 //   backgroundImage: `url('https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')`
//                 // }}
//                 ></div>
//                 <div className="absolute inset-0 bg-primary/90"></div>
//                 <div className="absolute inset-0 bg-grid"></div>

//                 <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//                     <div className="glass-card rounded-2xl p-8 md:p-12">
//                         <h2 className="text-4xl font-bold mb-6 text-primary">
//                             Ready to Get Started?
//                         </h2>
//                         <p className="text-xl text-gray-700 mb-8 font-semibold">
//                             Contact us today to learn how City Pulse can support your mortgage processing needs.
//                         </p>
//                         <a
//                             href="/contact"
//                             className="inline-block glass bg-accent/90 hover:bg-accent text-primary hover:text-white font-semibold py-3 px-8 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-lg"
//                         >
//                             Contact Us
//                         </a>
//                     </div>
//                 </div>
//             </section>
//         </div>
//     )
// }



import React from 'react'
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

export default function SettlementServices() {

    const serviceCategories = [
        {
            category: "Settlement Services",
            description:
                "Our comprehensive Settlement Services streamline the real estate closing process from preparation to post-closing fulfillment, delivering full regulatory compliance, precise documentation, and a smooth transfer of ownership for all parties involved.",
            services: [
                {
                    name: "Closing Disclosure Preparation",
                    icon: "📄",
                    details:
                        "Produces fully compliant Closing Disclosures in line with TRID requirements, compiling verified loan details, final fees, cash-to-close calculations, and comparisons to the Loan Estimate before secure delivery to borrowers and lenders."
                },
                {
                    name: "Pre-CD Preparation",
                    icon: "🗂️",
                    details:
                        "Develops preliminary Closing Disclosures to provide an advance, accurate preview of final loan terms, estimated costs, payment schedules, and adjustments—allowing early review, discrepancy resolution, and smoother finalization."
                },
                {
                    name: "Notary Scheduling",
                    icon: "✍️",
                    details:
                        "Arranges professional notary services (in-person, mobile, or remote online notarization where permitted), including prompt scheduling, identity verification coordination, secure signing sessions, and follow-up for document authentication and compliance."
                },
                {
                    name: "Policy Typing",
                    icon: "🖊️",
                    details:
                        "Prepares precise title insurance policies for both owners and lenders, gathering commitment details, customizing policy forms, assembling endorsements, performing final verifications, and ensuring error-free issuance ready for delivery."
                },
                {
                    name: "Post Closing Audit",
                    icon: "🔍",
                    details:
                        "Performs thorough post-closing quality reviews and compliance audits, examining all executed documents, fund disbursements, recording confirmations, and lien releases to identify and resolve any discrepancies while generating detailed reports."
                },
                {
                    name: "Recording",
                    icon: "🏛️",
                    details:
                        "Manages efficient document recording via electronic platforms (e.g., Simplifile, CSC) or traditional county methods, preparing packages, submitting deeds/mortgages promptly, tracking status, securing confirmations, and handling returned originals."
                },
                {
                    name: "Policy Mailing",
                    icon: "📬",
                    details:
                        "Oversees secure distribution of final title insurance policies through physical mailing or electronic upload to lender portals, including packaging, certified tracking, delivery verification, and archiving for future reference."
                },
            ],
        },
    ];

    const stats = [
        { value: "7+", label: "Core Services" },
        { value: "100%", label: "TRID Compliant" },
        { value: "48h", label: "Avg. Turnaround" },
        { value: "End-to-End", label: "Coverage" },
    ];

    return (
        <div className="bg-white">
            <Helmet>
                <meta charSet="utf-8" />
                <title>CityPulse LLC | Settlement Services</title>
                <link rel="canonical" href="https://citypulsellc.com/services" />
            </Helmet>

            {/* ── HERO ── */}
            <section className="relative min-h-[60vh] flex flex-col justify-center overflow-hidden bg-gray-950">

                {/* Background photo */}
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{
                        backgroundImage: `url('https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')`
                    }}
                />
                {/* Multi-layer overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-gray-950/85 via-gray-900/70 to-blue-900/50" />

                {/* Decorative blobs + dot grid */}
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-blue-500/20 blur-3xl" />
                    <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-indigo-500/10 blur-3xl" />
                    <div
                        className="absolute inset-0 opacity-10"
                        style={{
                            backgroundImage: `radial-gradient(circle, #fff 1px, transparent 1px)`,
                            backgroundSize: `32px 32px`,
                        }}
                    />
                </div>

                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 w-full">

                    {/* Eyebrow badge */}
                    <div className="flex items-center gap-3 mb-6">
                        <span className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-sm rounded-full px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-blue-300">
                            <span className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" />
                            City Pulse Services
                        </span>
                    </div>

                    {/* Headline */}
                    <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black text-white leading-none mb-6 max-w-3xl">
                        Settlement
                        <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-300 mt-1">
                            Services
                        </span>
                    </h1>

                    {/* Accent divider */}
                    <div className="flex items-center gap-4 mb-6">
                        <div className="h-px w-16 bg-gradient-to-r from-blue-400 to-transparent" />
                        <div className="w-2 h-2 rounded-full bg-blue-400" />
                    </div>

                    {/* Description */}
                    <p className="text-lg sm:text-xl text-gray-300 max-w-2xl leading-relaxed mb-12">
                        We provide end-to-end Settlement Services to ensure transparency, compliance, and successful real estate closings.
                    </p>

                    {/* Stats row */}
                    {/* <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-2xl">
                        {stats.map((stat, i) => (
                            <div
                                key={i}
                                className="bg-white/5 border border-white/10 backdrop-blur-sm rounded-2xl px-4 py-4 text-center hover:bg-white/10 transition-colors duration-200"
                            >
                                <div className="text-xl sm:text-2xl font-black text-white">{stat.value}</div>
                                <div className="text-xs text-gray-400 mt-0.5 font-medium">{stat.label}</div>
                            </div>
                        ))}
                    </div> */}

                    {/* Scroll hint */}
                    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-40">
                        <span className="text-white text-xs uppercase tracking-widest">Scroll</span>
                        <div className="w-px h-8 bg-gradient-to-b from-white to-transparent animate-bounce" />
                    </div>
                </div>
            </section>

            {/* ── SERVICES GRID ── */}
            <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                    {/* Section label */}
                    <div className="flex items-center gap-3 mb-3">
                        <div className="h-px w-10 bg-blue-600" />
                        <span className="text-xs font-bold uppercase tracking-widest text-blue-700">What We Handle</span>
                    </div>
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">
                        Our Settlement Capabilities
                    </h2>
                    <p className="text-gray-500 mb-12 max-w-2xl">
                        From disclosure prep to policy mailing — every step covered for a seamless closing experience.
                    </p>

                    {serviceCategories.map((category, index) => (
                        <div key={index} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                            {category.services.map((service, idx) => (
                                <div
                                    key={idx}
                                    className="group bg-white rounded-2xl p-6 shadow-sm hover:shadow-xl border border-gray-100 hover:border-blue-200 transition-all duration-300 flex flex-col gap-4"
                                >
                                    {/* Icon + Name */}
                                    <div className="flex justify-start items-center gap-3">
                                        <div className="flex-shrink-0 w-11 h-11 bg-blue-50 rounded-xl flex items-center justify-center text-xl group-hover:bg-blue-100 transition-colors">
                                            {service.icon}
                                        </div>
                                        <h3 className="text-base lg:text-lg 2xl:text-xl font-bold text-gray-900 leading-snug pt-1">
                                            {service.name}
                                        </h3>
                                    </div>

                                    {/* Divider */}
                                    <div className="h-px bg-gray-100 group-hover:bg-blue-100 transition-colors" />

                                    {/* Details */}
                                    {service.details && (
                                        <p className="text-sm lg:text-base text-gray-800 leading-relaxed flex-1">
                                            {service.details}
                                        </p>
                                    )}

                                    {/* Tag */}
                                    {/* <div className="self-start">
                                        <span className="text-xs font-semibold text-blue-700 bg-blue-50 px-2.5 py-1 rounded-full">
                                            Settlement
                                        </span>
                                    </div> */}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </section>

            {/* ── CTA SECTION ── */}
            <section className="relative py-20 overflow-hidden bg-gray-950">
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-blue-500/20 blur-3xl -translate-y-1/2 translate-x-1/2" />
                    <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-teal-500/15 blur-3xl translate-y-1/2 -translate-x-1/4" />
                    <div
                        className="absolute inset-0 opacity-5"
                        style={{
                            backgroundImage: `radial-gradient(circle, #fff 1px, transparent 1px)`,
                            backgroundSize: `28px 28px`,
                        }}
                    />
                </div>

                <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <span className="inline-block text-xs font-bold uppercase tracking-widest text-blue-400 mb-4">
                        Let's Work Together
                    </span>
                    <h2 className="text-4xl sm:text-5xl font-black text-white mb-4 leading-tight">
                        Ready to Get Started?
                    </h2>
                    <div className="w-16 h-1 bg-gradient-to-r from-blue-400 to-teal-300 rounded-full mx-auto mb-6" />
                    <p className="text-lg text-gray-400 mb-10 max-w-xl mx-auto leading-relaxed">
                        Contact us today to learn how City Pulse can support your mortgage processing needs.
                    </p>
                    <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                        <Link
                            to="/contact"
                            className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-semibold py-3.5 px-8 rounded-xl transition-all duration-200 hover:scale-105 shadow-xl shadow-primary/30 text-sm"
                        >
                            Contact Us
                            <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none">
                                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Link>
                        <Link
                            to="/services"
                            className="inline-flex items-center gap-2 border border-white/20 hover:border-white/40 text-gray-300 hover:text-white font-semibold py-3.5 px-8 rounded-xl transition-all duration-200 text-sm"
                        >
                            View All Services
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    )
}